import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map, tap, catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment'
import {BehaviorSubject, throwError} from 'rxjs';
import {User} from '../models/user';
import {UserSettings} from '../user.settings';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  private is_admin: boolean;

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<User>(null);
  }

  public get currentUserValue(): any {
    return this.currentUserSubject;
  }

  public set currentUserValue(userData: any) {
    let newUser = Object.assign({}, this.currentUserSubject.value, userData)
    this.currentUserSubject.next(newUser)
  }


  authUser() {
    return this.http.get<any>(environment.apiUrl + '/users/getAuthUser', {headers: UserSettings.headers()})
      .pipe(map(user => {
          if (user) {
            this.currentUserValue = user.data;
          }
          return user;
        }),
        catchError(
          error => {
            return throwError(error);
          }
        )
      );
  }
  login(email: string, password: string) {
    return this.http.post<any>(environment.apiUrl + '/login', {email, password})
      .pipe(map(user => {
          if (user) {
            console.log("hi")
            localStorage.setItem('userToken', user.token);
            this.currentUserSubject.next(user.user);
            return user.user;
          }
        }
        ),
        catchError(
          err => {
            throw new Error("You are not authorized");
          }
        ));
  }

  logout() {
    localStorage.removeItem('userToken');
  }


  loggedIn() {
    return !!localStorage.getItem('userToken');
  }
  isAdmin() {
    return this.currentUserValue.value.is_admin;
  }

}
